module.exports = __webpack_public_path__ + "img/certlogo.54e2ff03.png";